"use client";

import {
  createContext,
  useContext,
  useEffect,
  useState,
  ReactNode,
} from "react";

export type KeycloakAuthResult = {
  authenticated: boolean | null;
  isReady: boolean;
  user: any;
  login: () => void;
  logout: () => void;
};

const KeycloakServiceProvider = createContext<KeycloakAuthResult | null>(null);

type KeycloakAuthProviderProps = {
  children: ReactNode;
  // Claims Keycloak décodés côté serveur. On ne reçoit jamais l'access token
  // brut côté client : il reste dans le cookie HttpOnly et n'est utilisé que
  // par le proxy serveur /backend-api.
  user?: Record<string, any> | null;
};

export const KeycloakAuthProvider = (props: KeycloakAuthProviderProps) => {
  const { children, user } = props;
  const [state, setState] = useState({
    authenticated: null as boolean | null,
    user: null as any,
    isReady: false,
  });

  useEffect(() => {
    setState({
      authenticated: !!user,
      user: user ?? null,
      isReady: true,
    });
  }, [user]);

  async function login() {
    const redirect = encodeURIComponent(window.location.pathname);
    window.location.href = `/api/keycloak/authorize?redirect=${redirect}`;
  }

  async function logout() {
    const res = await fetch("/api/keycloak/logout", { method: "POST" });
    const { logoutUrl } = await res.json();
    window.location.href = logoutUrl;
  }

  return (
    <KeycloakServiceProvider.Provider value={{ ...state, login, logout }}>
      {children}
    </KeycloakServiceProvider.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(KeycloakServiceProvider);
  if (!context) {
    throw new Error(
      "useAuth doit être utilisé à l'intérieur de KeycloakAuthProvider",
    );
  }
  return context;
};
